export const setCaretPosition = {
    methods: {
        setCaretPosition(ctrl, start, end) {
            if (ctrl.setSelectionRange) {
                ctrl.focus();
                ctrl.setSelectionRange(start, end);
            } else if (ctrl.createTextRange) {
                const range = ctrl.createTextRange();
                range.collapse(true);
                range.moveEnd('character', end);
                range.moveStart('character', start);
                range.select();
            }
        },

    }
}